'use strict';

function ContentfulHelper() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this._initialized = false;
  this.modelRef = null;
  this.init = function () {};
  this.initAllReady = function () {};

  /*
    _loadContentfulImages: searches for elements that contain data-content-attr-src attribute
    uses the attribute to find the data in content model.
    creage image tag with the content image model via get_imageHtml
  */
  this._loadContentfulImages = function (modelRefString) {
    var _this = this;

    document.querySelectorAll('[data-content-attr-src]').forEach(function (element) {
      var imageUrlRef = modelRefString + '.' + element.dataset.contentAttrSrc;
      var imageObj = _this.presenter.getModelProperty(imageUrlRef);
      var imageUrl = imageObj.file.url;
      var imageAltTitle = imageObj.title;
      element.innerHTML = _this._createImageHTML(imageUrl, imageAltTitle);
    });
  };

  this._createImageHTML = function (url, alt) {
    return '<img class="media-item media-item__image js--image" src="' + url + '"  alt="' + alt + '" />';
  };

  this._loadContentfulBackgroundImage = function (modelRefString) {
    var _this2 = this;

    document.querySelectorAll('[data-content-bg-url]').forEach(function (element) {
      var imageUrlRef = modelRefString + '.' + element.dataset.contentBgUrl;
      var imageObj = _this2.presenter.getModelProperty(imageUrlRef);
      var imageUrl = imageObj.file.url;
      element.style.backgroundImage = 'url(' + imageUrl + ')';
    });
  };

  this._loadContentfulAnchorTag = function (modelRefString) {
    var _this3 = this;

    document.querySelectorAll('[data-content-anchor-src]').forEach(function (element) {
      var anchorUrlRef = modelRefString + '.' + element.dataset.contentAnchorSrc;
      var anchorObj = _this3.presenter.getModelProperty(anchorUrlRef);
      element.setAttribute('href', anchorObj);
    });
  };

  this._createAnchorHTML = function (url, alt) {
    return '<img class="media-item media-item__image js--image" src="' + url + '"  alt="' + alt + '" />';
  };

  this._loadLottiePlayer = function (modelRefString) {
    var _this4 = this;

    if (typeof bodymovin === 'undefined') {
      $.ajax({
        url: 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js',
        dataType: 'script',
        cache: true
      }).done(function () {
        document.querySelectorAll('[data-content-lottie-player]').forEach(function (element) {
          var imageUrlRef = modelRefString + '.' + element.dataset.contentLottiePlayer;
          var imageObj = _this4.presenter.getModelProperty(imageUrlRef);
          var imageUrl = imageObj.file.url;
          element.innerHTML = _this4._loadAnimationsPlayer(imageUrl);
        });
      });
    } else {
      document.querySelectorAll('[data-content-lottie-player]').forEach(function (element) {
        var imageUrlRef = modelRefString + '.' + element.dataset.contentLottiePlayer;
        var imageObj = _this4.presenter.getModelProperty(imageUrlRef);
        var imageUrl = imageObj.file.url;
        element.innerHTML = _this4._loadAnimationsPlayer(imageUrl);
      });
    }
  };

  this._loadAnimationsPlayer = function (loadUrl) {
    return '<lottie-player src="' + loadUrl + '" background="transparent" speed="1" loop autoplay></lottie-player>';
  };

  this._loadLottie = function (loadUrl, elemId) {
    this._loadAnimations(loadUrl, elemId);
  };

  this._loadAnimations = function (loadUrl, elemId) {
    var animationConfig = {
      container: document.getElementById(elemId),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: loadUrl
    };

    var animationObject = bodymovin.loadAnimation(animationConfig);
  };

  this._loadVideo = function (modelRefString) {
    var _this5 = this;

    document.querySelectorAll('[data-content-video]').forEach(function (element) {
      var videoUrlRef = modelRefString + '.' + element.dataset.contentVideo;
      var videoObj = _this5.presenter.getModelProperty(videoUrlRef);
      var videoUrl = videoObj.file.url;
      element.innerHTML = '<video autoplay="true" playsinline="true" loop="true" muted="true"><source  type="video/mp4" src="' + videoUrl + '"></video>';
    });
  };
}